import Add from '@mui/icons-material/Add'
import { Button } from '@mui/material'

export const TemplateReportActions = ({ setDisplayAddForm }) => {
  return (
    <Button
      color="primary"
      startIcon={<Add />}
      variant="contained"
      onClick={() => setDisplayAddForm(true)}
    >
      Nuevo Reporte
    </Button>
  )
}
